import React, { useMemo } from 'react';

import Image from '../../components/Image/Image';
import RetoureForm from '../../components/account/RetoureForm';
import Currency from '../../../helpers/currency';

const OrderContentService = props => {
    const { currentOrderState, frontEndOrderActions, orderId, product, markenStandort, showRetoureLink } = props;

    const images = useMemo(() => {
        const blobUrl = product?.isOwnArticle ? '' : 'https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/articles/';
        let images = [];

        if (product?.blobdatei) {
            images.push(blobUrl + product?.blobdatei);
        } else if (product?.bilddatei) {
            images.push(product?.bilddatei);
        }

        if (!images.length && product?.images) {
            images = product?.images.map(image => `https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${image.name}`);
        }

        return images;
    }, [product]);

    return (
        <div className="uk-child-width-1-1" data-uk-grid="">
            <div>
                <div data-uk-grid="">
                    <div className="uk-width-1-1 uk-width-1-6@s">
                        <div className="uk-flex uk-flex-center">
                            <Image src={images[0]} alt="Produktbild" style={{ maxHeight: 200 }} resizeHeight={200} />
                        </div>
                    </div>
                    <div className="uk-width-expand">
                        <h2>{product.serviceTitle}</h2>
                        <div dangerouslySetInnerHTML={{ __html: product.fahrzeugBeschreibung }} />
                        {product.angebotsBulletPoints && (
                            <ul className="uk-list uk-list-disc uk-margin-small-bottom">
                                {product.angebotsBulletPoints.map(bullet => (
                                    <li key={bullet}>{bullet}</li>
                                ))}
                            </ul>
                        )}
                        {currentOrderState && (
                            <div>
                                Status: <span className="uk-text-primary">{currentOrderState?.orderStatusLabel ?? '---'}</span>
                            </div>
                        )}
                        {markenStandort && (
                            <div>
                                Autohaus: <span className="uk-text-primary">{markenStandort.anschrift.firma}</span>,{' '}
                                {markenStandort.anschrift.strasse} {markenStandort.anschrift.plz} {markenStandort.anschrift.ort}
                            </div>
                        )}
                    </div>
                    <div className="uk-width-1-1 uk-width-auto@s uk-flex uk-flex-right">
                        <table className="uk-table uk-table-small">
                            <thead>
                                <tr>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Menge</th>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Einzelpreis</th>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Summe</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="uk-text-right">
                                    <td>{product.quantity}</td>
                                    <td>
                                        <Currency quantity={product.preis.komplettPreis} />
                                    </td>
                                    <td className="uk-text-bold">
                                        <Currency quantity={product.preis.komplettPreis} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {showRetoureLink && (
                <div>
                    {frontEndOrderActions.map(action => (
                        <RetoureForm key={action._id} action={action} orderId={orderId} productId={product._id} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default OrderContentService;
